import { render, staticRenderFns } from "./SelectFilters.vue?vue&type=template&id=3c87da9e"
import script from "./SelectFilters.vue?vue&type=script&lang=js"
export * from "./SelectFilters.vue?vue&type=script&lang=js"
import style0 from "./SelectFilters.vue?vue&type=style&index=0&id=3c87da9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports